/** @graphql cc **/

import gql from 'graphql-tag';

export const RecentlyViewedQuery = gql`
	query RecentlyViewedQuery(
		$cloudId: ID!
		$first: Int
		$after: String
		$eventTypes: [ActivityEventType!]
		$objectTypes: [ActivitiesObjectType!]
	) {
		activities {
			myActivities {
				all(
					filters: [
						{
							type: AND
							arguments: {
								products: [CONFLUENCE]
								objectTypes: $objectTypes
								cloudIds: [$cloudId]
								eventTypes: $eventTypes
							}
						}
					]
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							timestamp
							object {
								id
								events {
									eventType
								}
								content {
									id
									type
									subType
									title
									status
									blank
									metadata {
										currentuser {
											favourited {
												isFavourite
												favouritedDate
											}
											lastcontributed {
												status
												when
											}
											scheduled {
												isScheduled
											}
										}
									}
									links {
										webui
										editui
									}
									editorVersion: properties(key: "editor") {
										nodes {
											id
											key
											value
										}
									}
									space {
										id
										key
										name
									}
									emoji: properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
										nodes {
											id
											key
											value
										}
									}
								}
							}
						}
					}
					pageInfo {
						hasNextPage
					}
				}
			}
		}
	}
`;

export const RecentlyWorkedOnQuery = gql`
	query RecentlyWorkedOnQuery(
		$cloudId: ID!
		$first: Int
		$after: String
		$eventTypes: [ActivityEventType!]
		$objectTypes: [ActivitiesObjectType!]
	) {
		activities {
			myActivities {
				all(
					filters: [
						{
							type: AND
							arguments: {
								products: [CONFLUENCE]
								objectTypes: $objectTypes
								cloudIds: [$cloudId]
								eventTypes: $eventTypes
							}
						}
					]
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							timestamp
							object {
								id
								events {
									eventType
								}
								content {
									id
									type
									subType
									title
									status
									blank
									metadata {
										currentuser {
											favourited {
												isFavourite
												favouritedDate
											}
											lastcontributed {
												status
												when
											}
											scheduled {
												isScheduled
											}
										}
									}
									links {
										webui
										editui
									}
									editorVersion: properties(key: "editor") {
										nodes {
											id
											key
											value
										}
									}
									space {
										id
										key
										name
									}
									emoji: properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
										nodes {
											id
											key
											value
										}
									}
								}
							}
						}
					}
					pageInfo {
						hasNextPage
					}
				}
			}
		}
	}
`;

export const RecentActivityQuery = gql`
	query RecentActivityQuery(
		$cloudId: ID!
		$first: Int
		$after: String
		$eventTypes: [String!]
		$objectTypes: [String!]
	) {
		activity {
			myActivity {
				all(
					filter: {
						type: AND
						rootContainerIds: [$cloudId]
						arguments: {
							products: ["CONFLUENCE"]
							objectTypes: $objectTypes
							eventTypes: $eventTypes
						}
					}
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							object {
								id
								data {
									... on ConfluencePage {
										id
										title
										type
										subtype
										pageStatus: status
										links {
											webUi
											editUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
											lastContribution {
												status
											}
										}
										space {
											id
											alias
											key
											name
										}
										editorVersion: properties(keys: ["editor"]) {
											value
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceBlogPost {
										id
										title
										type
										blogStatus: status
										links {
											webUi
											editUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
											lastContribution {
												status
											}
										}
										space {
											id
											alias
											key
											name
										}
										editorVersion: properties(keys: ["editor"]) {
											value
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceWhiteboard {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
									}
									... on ConfluenceDatabase {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
									}
									... on ConfluenceEmbed {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
								}
							}
							event {
								timestamp
								eventType
							}
						}
					}
				}
			}
		}
	}
`;

export const RecentlyCreatedByMeQuery = gql`
	query RecentlyCreatedByMeQuery($cql: String!, $cqlcontext: String!, $first: Int, $after: String) {
		search: confluence_search(cql: $cql, cqlcontext: $cqlcontext, first: $first, after: $after) {
			nodes {
				url
				content {
					id
					type
					subType
					title
					status
					blank
					metadata {
						currentuser {
							favourited {
								isFavourite
								favouritedDate
							}
							lastcontributed {
								status
								when
							}
							scheduled {
								isScheduled
							}
						}
					}
					links {
						webui
						editui
					}
					editorVersion: properties(key: "editor") {
						nodes {
							id
							key
							value
						}
					}
					space {
						id
						key
						name
					}
					emoji: properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
						nodes {
							id
							key
							value
						}
					}
					space {
						alias
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const RecentlyDraftedQuery = gql`
	query RecentlyDraftedQuery($first: Int, $after: String, $context: String) {
		search: confluence_search(
			cql: "type in (page,blogpost) order by lastModified desc"
			cqlcontext: $context
			first: $first
			after: $after
		) {
			nodes {
				entityType
				url
				content {
					id
					type
					subType
					title
					status
					blank
					metadata {
						currentuser {
							favourited {
								isFavourite
								favouritedDate
							}
							lastcontributed {
								status
								when
							}
							scheduled {
								isScheduled
							}
						}
					}
					links {
						webui
						editui
					}
					editorVersion: properties(key: "editor") {
						nodes {
							id
							key
							value
						}
					}
					space {
						id
						key
						name
					}
					emoji: properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
						nodes {
							id
							key
							value
						}
					}
					space {
						alias
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const RecentlyStarredQuery = gql`
	query RecentlyStarredQuery($limit: Int, $start: Int) {
		favoriteContent(limit: $limit, start: $start) {
			nodes {
				id
				type
				subType
				title
				status
				blank
				metadata {
					currentuser {
						favourited {
							isFavourite
							favouritedDate
						}
						lastcontributed {
							status
							when
						}
						scheduled {
							isScheduled
						}
					}
				}
				links {
					webui
					editui
				}
				editorVersion: properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
				space {
					id
					key
					name
				}
				emoji: properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
					nodes {
						id
						key
						value
					}
				}
			}
			pageInfo {
				hasNextPage
			}
		}
	}
`;
